import React from 'react';

const TotalOverview = () => {
    return (
       <div className='bg-cs-clr mt-5'>
         <div className='d-flex justify-content-evenly container my-5 p-5'>
          <div>
            <h1>150+</h1>
            <p>Enrolled</p>
          </div>
          <div>
          <h1>9+</h1>
            <p>Courses</p>
          </div>
          <div>
          <h1>10+</h1>
            <p>Trainers</p>
          </div>
        </div>
       </div>
    );
};

export default TotalOverview;